import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sun, Moon, MessageSquare } from "lucide-react";
import Sidebar from "./Sidebar";
import ChatPanel from "./ChatPanel";
import { useTheme } from "../contexts/ThemeContext";
import { ChatProvider, useChat } from "../contexts/ChatContext";

function LayoutInner() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { chatOpen, setChatOpen } = useChat();
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="flex h-screen overflow-hidden bg-gray-950 dark:bg-gray-950 light:bg-gray-50">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed((v) => !v)}
      />

      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Top bar */}
        <header className="h-16 flex items-center justify-end gap-2 px-6 border-b border-gray-800 dark:border-gray-800 flex-shrink-0 bg-gray-900 dark:bg-gray-900">
          <button
            onClick={() => setChatOpen(!chatOpen)}
            className={`p-2 rounded-lg transition-colors ${
              chatOpen
                ? "bg-brand-600/20 text-brand-400"
                : "text-gray-400 hover:text-gray-100 hover:bg-gray-800"
            }`}
            title="AI Assistant"
          >
            <MessageSquare className="w-4 h-4" />
          </button>
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg text-gray-400 hover:text-gray-100 hover:bg-gray-800 transition-colors"
            title="Toggle theme"
          >
            {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
        </header>

        {/* Main content */}
        <main className="flex-1 overflow-y-auto bg-gray-950 dark:bg-gray-950 p-6">
          <Outlet />
        </main>
      </div>

      {/* Chat panel — inline flex child, pushes main content left */}
      {chatOpen && (
        <div className="flex-shrink-0 h-full">
          <ChatPanel open={chatOpen} onClose={() => setChatOpen(false)} />
        </div>
      )}
    </div>
  );
}

export default function Layout() {
  return (
    <ChatProvider>
      <LayoutInner />
    </ChatProvider>
  );
}
